import { useTranslation } from 'react-i18next';
import type { UserStatus } from '../../api/types';

export function UserStatusPill({ status }: { status: UserStatus }) {
  const { t } = useTranslation();
  const cls = status === 'blocked' ? 'off' : status === 'invited' ? 'lab' : 'ok';
  return <span className={`pill ${cls}`}>{t(`admin.userStatus.${status}`)}</span>;
}
